import Assignment from '@/components/assignment/assignment';
import AssignmentTabs from '@/components/assignment/assignment-tabs';
import FactorTablesModal from '@/components/factor-tables/factor-tables-modal';

const AssignmentDetailPage = () => {
  return (
    <div className="max-w-[1200px] mx-auto">
      <AssignmentTabs />

      <div className="bg-white rounded-b-xl shadow-sm border border-gray overflow-hidden">
        <div className="py-8 text-black">
          <div className="space-y-8">
            <Assignment />
          </div>
        </div>
      </div>

      <FactorTablesModal />
    </div>
  );
};

export default AssignmentDetailPage;
